/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface PatchCustomerWithRuVFlag$Params {
  customerId: string;
  ruvInsured: boolean;
}

export function patchCustomerWithRuVFlag(http: HttpClient, rootUrl: string, params: PatchCustomerWithRuVFlag$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, patchCustomerWithRuVFlag.PATH, 'patch');
  if (params) {
    rb.path('customerId', params.customerId, {});
    rb.path('ruvInsured', params.ruvInsured, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

patchCustomerWithRuVFlag.PATH = '/customer/{customerId}/ruvflag/{ruvInsured}';
